import service from "../Assets/svg/icon/Service_nv.svg";
import mastic from "../Assets/svg/icon/Mastic_nv.svg";
import flashing from "../Assets/svg/icon/Rokob_nv.svg";
import net from "../Assets/svg/icon/Lace_nv.svg";
import glass from "../Assets/svg/icon/Glass_nv.svg";
import fitting from "../Assets/svg/icon/DoorHandle_nv.svg";
import profile from "../Assets/svg/icon/Profile_nv.svg";

export const propertiesMenuItems = [{
    "id": 7,
    "menu_title": "services",
    "menu_icon": service,
    "path": "/dashboard/properties/service",
},{
    "id": 6,
    "menu_title": "FoamMastic",
    "menu_icon": mastic,
    "path": "/dashboard/properties/other",
},{
    "id": 5,
    "menu_title": "rokob",
    "menu_icon": flashing,
    "path": "/dashboard/properties/flashing",
},{
    "id": 4,
    "menu_title": "shishe",
    "menu_icon": glass,
    "path": "/dashboard/properties/glass",
},{
    "id": 3,
    "menu_title": "tori",
    "menu_icon": net,
    "path": "/dashboard/properties/net",
},{
    "id": 2,
    "menu_title": "yaragh",
    "menu_icon": fitting,
    "path": "/dashboard/properties/fitting",
},{
    "id": 1,
    "menu_title": "profile",
    "menu_icon": profile,
    "path": "/dashboard/properties/profile",
} ]